exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".csp-button-padding-30 {\r\n    padding-left:30px !important;\r\n}\r\n\r\n.body .row {\r\n    padding: 8px 0;\r\n}\r\n.link-txt {\r\n    color: var(--font-and-label);\r\n    cursor: pointer;\r\n}\r\n.link-txt:hover {\r\n    text-decoration: underline;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/authentication.component.css
// module id = ../../../../../client/app/shared/common/authentication.component.css
// module chunks = main